// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import './Code.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Tooltip } from 'ui_kit_qmd'
import closeIcon from '../../../../images/common/close-small.png'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const Code = ({ code, description, isReadOnly, id, deleteCode }) => {
  const [maxWidth, setMaxWidth] = useState(540)

  useEffect(() => {
    // @ts-expect-error TS2531 -- MIGRATION: not approved, fix when encountered
    setMaxWidth(document.querySelector(isReadOnly ? '.code-read-only-container' : '.code-container').offsetWidth - 60)
    window.onresize = () => {
      const element = document.querySelector(isReadOnly ? '.code-read-only-container' : '.code-container')
      if (element) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setMaxWidth(element.offsetWidth - 60)
      }
    }
    return () => {
      window.onresize = null
    }
  }, [])

  return isReadOnly ?
      <div className='code-read-only-container'>
        <label htmlFor='null' className='code-read-only-text'>
          {code}
        </label>
        <Tooltip content={`${description}`} maxWidth={maxWidth} targetId={`code-read-only-description-${id}`}>
          <label htmlFor='null' id={`code-read-only-description-${id}`} className='code-read-only-text ellipses'>
            {description}
            <div />
          </label>
        </Tooltip>
      </div>
    : <div className='code-container'>
        <div className='code-block-container'>
          <Tooltip content={`${code} (${description})`} maxWidth={maxWidth} targetId={`code-title-${id}`}>
            <label htmlFor='null' className='code-title' id={`code-title-${id}`}>
              <strong>{code}</strong>
              {` (${description})`}
            </label>
          </Tooltip>
          <img
            src={closeIcon}
            className='code-close-icon'
            role='presentation'
            alt='Remove code'
            onClick={() => {
              deleteCode(id)
            }}
          />
        </div>
      </div>
}
